const prefix = 'SourcingProjectSourceSystem';

export enum SourcingProjectSourceSystemField {
  INTERNAL_ID = `${prefix}.internalId`,
  SOURCE_SYSTEM = `${prefix}.sourceSystem`,
  SOURCE_REFERENCE = `${prefix}.sourceReference`,
  IS_PRIMARY = `${prefix}.isPrimary`,
  LINK = `${prefix}.link`,
}

export interface SourcingProjectSourceSystemData {
  internalId: string;
  sourceSystem: string;
  sourceReference: string;
  isPrimary: boolean;
  link?: string | null;
}
